import { render, staticRenderFns } from "./DraggableFilePreview.vue?vue&type=template&id=6d455838&scoped=true&"
import script from "./DraggableFilePreview.vue?vue&type=script&lang=ts&"
export * from "./DraggableFilePreview.vue?vue&type=script&lang=ts&"
import style0 from "./DraggableFilePreview.vue?vue&type=style&index=0&id=6d455838&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d455838",
  null
  
)

export default component.exports